function appendText(parent, text) {
    text.split("\n").forEach((line, index) => {
        if (index > 0) {
            parent.appendChild(document.createElement("br"));
        }

        parent.appendChild(document.createTextNode(line));
    });
}

function appendToken(parent, token, text) {
    if (!token) {
        appendText(parent, text);
        return;
    }

    const element = document.createElement(token === "**" ? "strong" : "em");
    appendText(element, text);
    parent.appendChild(element);
}

function formatMarkdownText(element) {
    const source = element.textContent.trim();
    const fragment = document.createDocumentFragment();
    const pattern = /(\*\*|\*)([^*]+?)\1/g;
    let cursor = 0;
    let match;

    while ((match = pattern.exec(source)) !== null) {
        appendText(fragment, source.slice(cursor, match.index));
        appendToken(fragment, match[1], match[2]);
        cursor = pattern.lastIndex;
    }

    appendText(fragment, source.slice(cursor));
    element.replaceChildren(fragment);
}

export default function formatMarkdownTextBlocks() {
    document.querySelectorAll("[data-lds-markdown]").forEach(formatMarkdownText);
}
